import { render, staticRenderFns } from "./EventCard.vue?vue&type=template&id=a2b46556&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"
import style0 from "./EventCard.vue?vue&type=style&index=0&id=a2b46556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b46556",
  null
  
)

export default component.exports